import { easyPost } from './utils';

// 领取权益
// eslint-disable-next-line
export const getProperty = easyPost('aries.property.getProperty');
